module.exports = __webpack_public_path__ + "img/success.866f3edc.svg";